const styles = {
  // body: {
  //   fontFamily: "Roboto, Open Sans, sans-serif",
  //   fontSize: "16px",
  //   background: "red",
  //   height: "45px",
  // },
  input: {
    fontSize: "20px",
    border: "1px solid gray",
    padding: "24px 12px",
    borderRadius: "8px",
  },
  img: {
    top: "8px!important",
    right: "8px!important",
  },
  brand: {
    top: "8px",
    right: "8px",
  },
}
export const CloverInstance = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  instance: undefined as any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  elements: undefined as any,
  init: function (publicKey: string) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if((window as any)?.Clover) {
      // const clover = new (window as any).Clover(publicKey)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.instance = new (window as any).Clover(publicKey)
      this.elements = this.instance.elements()
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  bindingForm: function (callback: any) {
    const cardNumber = this.elements.create("CARD_NUMBER", styles)
    const cardDate = this.elements.create("CARD_DATE", styles)
    const cardCvv = this.elements.create("CARD_CVV", styles)
    const cardPostalCode = this.elements.create("CARD_POSTAL_CODE", styles)
      
    cardNumber.mount("#card-number")
    cardDate.mount("#card-date")
    cardCvv.mount("#card-cvv")
    cardPostalCode.mount("#card-postal-code")
    // const cardResponse = document.getElementById('card-response');
    // const displayCardNumberError = document.getElementById('card-number-errors');
    // const displayCardDateError = document.getElementById('card-date-errors');
    // const displayCardCvvError = document.getElementById('card-cvv-errors');
    // const displayCardPostalCodeError = document.getElementById('card-postal-code-errors');

    // Handle real-time validation errors from the card element
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    cardNumber.addEventListener("change", function(event: any) {
      callback(JSON.stringify(event))
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    cardNumber.addEventListener("blur", function(event: any) {
      callback(JSON.stringify(event))
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    cardDate.addEventListener("change", function(event: any) {
      callback(JSON.stringify(event))
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    cardDate.addEventListener("blur", function(event: any) {
      callback(JSON.stringify(event))
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    cardCvv.addEventListener("change", function(event: any) {
      callback(JSON.stringify(event))
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    cardCvv.addEventListener("blur", function(event: any) {
      callback(JSON.stringify(event))
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    cardPostalCode.addEventListener("change", function(event: any) {
      callback(JSON.stringify(event))
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    cardPostalCode.addEventListener("blur", function(event: any) {
      callback(JSON.stringify(event))
    })

    const form = document.getElementById("payment-form") as HTMLFormElement
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this
    form.addEventListener("submit", function(event) {
      event.preventDefault()
      // Use the iframe's tokenization method with the user-entered card details
      self.instance.createToken()
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((result: { errors: { [s: string]: unknown } | ArrayLike<unknown>; token: any }) => {
          if(result?.errors) {
            Object.values(result.errors).forEach(function (value) {
              // displayError.textContent = value;
              console.log(value)
            })
          } else {
            console.log(result, "RUN")
            // self.cloverTokenHandler(result.token)
          }
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((err:any) => console.log(err))
    })
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getCardToken: function (callback: any) {
    const data = {
      token: "",
      isGet: true,
    }
    this.instance.createToken()
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((result: { errors: { [s: string]: unknown } | ArrayLike<unknown>; token: any }) => {
        if(result?.errors) {
          Object.values(result.errors).forEach(function (value) {
            // displayError.textContent = value;
            console.log(value)
          })
        } else {
          data.token = result.token
        }
        callback(data)
        
      })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .catch((err:any) => console.log(err))
  },
}
